import { useBackupStatus } from '@/hooks/useBackupStatus';
import { describeBackupStatus } from '@/utils/backupStatusView';
import { BackupStatusDot } from './BackupStatusDot';

/**
 * Voyant « sauvegardes » de l'en-tête. Super admin seulement : pour les autres, rien n'est rendu et aucune requête n'est faite.
 * Le serveur refait le contrôle (le masquage ici n'est qu'un confort d'affichage).
 */
export function BackupStatusLight() {
  const { enabled, data, isError, denied, dataUpdatedAt } = useBackupStatus();

  if (!enabled || denied) return null;

  const view = describeBackupStatus({
    data,
    // Pas encore de donnée et pas d'erreur : première lecture en cours, on n'affiche rien plutôt qu'un faux état.
    unreachable: isError,
    dataUpdatedAt,
    now: new Date(),
  });
  if (!data && !isError) return null;

  return <BackupStatusDot state={view.state} title={view.title} label={view.label} />;
}
